import cornerstone from 'cornerstone-core';
import cornerstoneMath from 'cornerstone-math';
import cornerstoneTools from 'cornerstone-tools';
import dicomParser from 'dicom-parser';
import cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader';
import * as Hammer from 'hammerjs';
import dicomfileImageLoader from './dicomfile-loader.ts';
import dicomfileRawLoader from './dicomfile-raw-loader.ts';
import wadouriRedactLoader from './wadouri-redact-loader.ts';
import { setCacheBudget, noteFrameSize } from './cache-budget.ts';

cornerstoneTools.external.cornerstone = cornerstone;
cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
cornerstoneTools.external.Hammer = Hammer;
cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.cornerstoneMath = cornerstoneMath;
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
cornerstoneTools.init();

cornerstoneTools.toolColors.setToolColor('#3DD0FC');
cornerstoneTools.toolColors.setActiveColor('#86d3f7');

const { state } = cornerstoneTools.store;
state.preventHandleOutsideImage = true;

cornerstoneWADOImageLoader.configure();

// dicomfile-raw: is the internal sub-scheme used by dicomfileImageLoader to delegate first-load
// byte-fetching + decode without going through our OPFS wrapper. We use a thin custom loader (not
// cornerstoneWADOImageLoader.wadouri.loadImage) so each frame is decoded from a tight, frame-sized
// buffer instead of a view onto the whole P10 file — see dicomfile-raw-loader.ts for why this is a
// large multiframe load-speed win.
cornerstone.registerImageLoader('dicomfile-raw', dicomfileRawLoader);
// Override WADO's dicomfile: registration with our source-backed loader.
cornerstone.registerImageLoader('dicomfile', dicomfileImageLoader);
// Override WADO's own registrations so DICOMweb frames get redaction applied at
// decode time too — they have no local file to re-read, but an evicted frame must
// still come back redacted. Must run after configure(), which registers them.
cornerstone.registerImageLoader('wadouri', wadouriRedactLoader);
cornerstone.registerImageLoader('dicomweb', wadouriRedactLoader);

cornerstoneWADOImageLoader.webWorkerManager.initialize({
  maxWebWorkers: 4,
  startWebWorkersOnDemand: true,
  webWorkerTaskPaths: [],
  taskConfiguration: {
    decodeTask: {
      initializeCodecsOnStartup: true,
      strict: true,
    },
  },
});

/**
 * Set the memory budget shared by resident source files and cached frames. Called
 * with no argument to restore the default. See cache-budget.ts — the ceiling is
 * deliberately not expressible as "unbounded".
 */
export function setCornerstoneCacheLimit(bytes) {
  setCacheBudget(bytes);
}

export { noteFrameSize };

export { cornerstoneTools, cornerstone, cornerstoneWADOImageLoader, cornerstoneMath };
